export default __webpack_public_path__ + "static/media/back_webtoon_01.242cefd4.png";